type State = {
  initialized: boolean;
  sessionState: string;
  token: string;
  expires: string;
};

export const state: State = {
  initialized: false,
  sessionState: null,
  token: null,
  expires: null,
};
